import type { IUnifiedOrderBlotterEntry } from 'apiConnector/blotters';
import type { BlotterGridDispatchProps, BlotterGridStateProps } from 'components/shared/Blotter/Grid/blotter.model';
import { connect } from 'react-redux';
import { blotterPanelItemDetailsClickedThunk } from 'state/blotters/blotterPanel/blotterPanel.thunks';
import {
  secondaryMarketOrderBlotterColumnStateChanged,
  secondaryMarketOrdersBlotterDisplayedItemsCntChanged,
} from 'state/blotters/secondaryMarketOrderBlotter';
import { fromSecondaryOrderBlotter } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import * as routerSelectors from '../../../../state/selectors/common/router';

export type SecondaryMarketBlotterGridStateProps = BlotterGridStateProps<IUnifiedOrderBlotterEntry> & {
  isSecondaryMarketPostTradeRedirectionAllowed: boolean;
  pagination?: boolean;
};

export type SecondaryMarketBlotterGridDispatchProps = BlotterGridDispatchProps<IUnifiedOrderBlotterEntry>;
const mapStateToProps = (state: AppState): SecondaryMarketBlotterGridStateProps => {
  return {
    items: fromSecondaryOrderBlotter.getPageItems(state),
    columnDefinitions: fromSecondaryOrderBlotter.getColumnDefinition(state),
    ...fromSecondaryOrderBlotter.getPreferenceState(state),
    isSecondaryMarketPostTradeRedirectionAllowed: routerSelectors.isSecondaryPostEventVisible(state),
    pagination: false,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): SecondaryMarketBlotterGridDispatchProps => ({
  onBlotterColumnStateChanged(columnState: readonly any[]) {
    dispatch(secondaryMarketOrderBlotterColumnStateChanged(columnState));
  },
  onSetActiveItem(item) {
    dispatch(blotterPanelItemDetailsClickedThunk('orders', item?.orderId));
  },
  onDisplayItemsCntChanged(itemsCnt) {
    dispatch(secondaryMarketOrdersBlotterDisplayedItemsCntChanged(itemsCnt));
  },
});

export const connectSecondaryMarketOrderBlotterGrid = connect(mapStateToProps, mapDispatchToProps);
